import flatten from 'lodash/flatten';
import cloneDeep from 'lodash/cloneDeep';
import fetch from '@/utils/fetch';
import { parseGeoInfoToMapData, isObject } from '../../views/plan/utils';
// import { Pop } from '@/utils';
import syzIcon from '../../views/plan/images/shengyazhan.png';
import fengjiIcon from '../../views/plan/images/fengji.png';
import activeFengjiIcon from '../../asset/windfarm/turbine3.png';
import { eventBus } from '../../views/plan/utils';
import gantaIcon from '../../asset/windfarm/tower.png';
import activeGantaIcon from '../../asset/windfarm/tower1.png';
import entryPoint from '../../views/plan/images/entrypoint.svg';
import keyPointSrc from '../../views/plan/images/keypoint.svg';
import L from 'leaflet';
import { flattenDepth } from 'lodash';

let storeActiveId = -1;
let storeGantaActiveId = -1;

function findDeepObj(item, callback = () => {}) {
  if (!item) return '';

  if (Array.isArray(item)) {
    item.forEach(i => {
      findDeepObj(i, callback);
    });
  } else if (isObject(item)) {
    return callback(item);
  }
}

const state = {
  mapData: {
    points: [],
    polylines: [],
    polygons: [],
    rectangles: [],
    images: [],
    markers: []
  },
  // activePointItem:
  drawOptions: {},

  windFarmIsEdit: false,

  isInlinePage: false,
  projectList: [], // 风资源列表
  toolUIStatus: {
    exclusive: false,
    search: false,
    marker: false,
    rectangle: false,
    polygon: false,
    newFarm: false,
    importFarm: false,
    shengyazhanAdd: false,
    limitAdd: false,
    entrance: false,
    keyPoint: false,
    lxLimitAdd: false,
    fengji: false
  },

  wrgInfoForm: {},
  resourceTupuObj: {},

  activeTupu: -1,

  rawPolygons: {},
  rawMarkers: {},
  rawLines: {},
  roadLength: '',

  toolbarStatus: {
    drag: false,
    edit: false,
    remove: false,
    drawCircleMarker: false,
    drawMarker: false,
    drawPolyline: false,
    drawRectangle: false,
    drawPolygon: false
  },

  windFarmList: [],

  // 限制区域
  exclusiveList: [],
  boosterList: [],
  roadLine: [],
  keyPointsList: [],
  entrancePointList: [],
  gantaPointList: [],
  dataSet: [],
  turbineList: [],

  windfarmRoadList: [],

  windfarmWireList: [],

  windfarmWireForm: {},

  roadSlope: '',

  specificDragFlag: false,

  specificEditFlag: false,

  specificChangeFlag: false,

  showFengjiNoFlag: false,

  polylinesIndexs: []
};

const getters = {
  mapData: state =>
    state.mapData || {
      points: [],
      polylines: [],
      polygons: [],
      rectangles: [],
      images: [],
      markers: []
    },
  toolUIStatus: state => {
    return { ...state.toolUIStatus };
  },
  exclusiveList: state => {
    return [...state.exclusiveList];
  },
  boosterList: state => {
    return [...state.boosterList];
  },
  roadLine: state => {
    return [...state.roadLine];
  },
  projectList: state => {
    return [...state.projectList];
  },
  keyPointsList: state => {
    return [...state.keyPointsList];
  },
  entrancePointList: state => {
    return [...state.entrancePointList];
  },
  dataSet: state => {
    return [...state.dataSet];
  },
  turbineList: state => {
    return [...state.turbineList];
  },
  windfarmRoadList: state => {
    return [...state.windfarmRoadList];
  },

  windfarmWireList: state => {
    return [...state.windfarmWireList];
  },

  gantaPointList: state => {
    return [...state.gantaPointList];
  },

  drawOptions: state => {
    return state.drawOptions;
  },

  windFarmIsEdit: state => {
    return state.windFarmIsEdit;
  },

  roadSlope: state => {
    return state.roadSlope;
  },
  specificDragFlag: state => state.specificDragFlag,
  specificEditFlag: state => state.specificEditFlag,
  specificChangeFlag: state => state.specificChangeFlag,
  polylinesIndexs: state => state.polylinesIndexs,
  wrgInfoForm: state => ({ ...state.wrgInfoForm }),
  resourceTupuObj: state => ({ ...state.resourceTupuObj }),
  activeTupu: state => state.activeTupu,
  windfarmWireForm: state => state.windfarmWireForm,
  roadLength: state => state.roadLength,
  isInlinePage: state => state.isInlinePage
};

const mutations = {
  /*SET_TOWERLIST(state, payload) {
  },
  UPDATE_TOWER_AREA(state, payload) {
  },
  SET_POWERTURLIST(state, payload) {
  },
  UPDATE_POWERLIST(state, payload) {
  },*/
  SET_INLINEPAGE(state, payload) {
    state.isInlinePage = payload;
  },
  SET_PROJECTLIST(state, payload) {
    state.projectList = payload;
  },
  SET_WINDFARM_EDIT_STATE(state, flag) {
    state.windFarmIsEdit = flag;
  },
  SET_FENGJIBIANHAOFLAG(state, flag) {
    state.showFengjiNoFlag = flag;
  },
  SET_DRAWCOLOR(state, color) {
    if (!color) {
      state.drawOptions = {
        templineStyle: {
          color: '#478beb'
        },
        snapDistance: 5,
        // the line from the last marker to the mouse cursor
        hintlineStyle: {
          color: '#478beb',
          dashArray: [5, 5]
        }
      };
    } else {
      state.drawOptions = {
        templineStyle: {
          color: color
        },
        snapDistance: 5,
        // the line from the last marker to the mouse cursor
        hintlineStyle: {
          color: color,
          dashArray: [5, 5]
        }
      };
    }
  },

  SET_ACTIVE_TUPU_INDEX(state, payload) {
    state.activeTupu = payload;
  },

  SET_FARM_LIST(state, payload) {
    state.windFarmList = [...payload];
  },
  SET_TYPE(state, { type, data }) {
    state.mapData[type] = data;
    state.mapData = {
      ...state.mapData
    };
  },
  SET_MARKERS(state, markers) {
    this.commit('WindFarm/SET_TYPE', {
      type: 'markers',
      data: markers
    });
  },

  SET_WIRE_LIST(state, payload) {
    state.windfarmWireList = [...payload];
  },

  SET_PONITS(state, points) {
    this.commit('WindFarm/SET_TYPE', {
      type: 'points',
      data: points
    });
  },

  SET_POLYGONS(state, polygons) {
    this.commit('WindFarm/SET_TYPE', {
      type: 'polygons',
      data: polygons
    });
  },

  SET_LINE(state, lineArr) {
    this.commit('WindFarm/SET_TYPE', {
      type: 'polylines',
      data: lineArr
    });
  },

  SET_IMAGE(state, imgArr) {
    this.commit('WindFarm/SET_TYPE', {
      type: 'images',
      data: imgArr
    });
  },

  SET_RECT(state, rectangles) {
    this.commit('WindFarm/SET_TYPE', {
      type: 'rectangles',
      data: rectangles
    });
  },

  SET_RAW_LINE(state, payload) {
    const { type, data = [], t = 'obj' } = payload;

    state.rawLines[type] = {
      data: data.reduce((acc, item) => {
        if (Array.isArray(item)) {
          if (t === 'obj') {
            acc.push(item.map(i => ({ ...i, type })));
            return acc;
          }
          return [...acc, ...item];
        }
        return acc;
      }, []),
      index: []
    };

    const arr = [];
    Object.keys(state.rawLines).forEach((i, index) => {
      arr[index] = state.rawLines[i].data;
    });

    const newArr = flatten(arr);
    this.commit('WindFarm/SET_LINE', [...newArr]);
  },

  SET_RAW_POLYGONS_ARR(state, payload) {
    const { type, data = [] } = payload;

    state.rawPolygons[type] = {
      data: data.map(item => {
        if (Array.isArray(item)) {
          item = item.map(i => [...i]);
        }
        return item;
      })
    };

    const arr = [];
    Object.keys(state.rawPolygons).forEach((i, index) => {
      arr[index] = state.rawPolygons[i].data;
    });

    const newArr = flatten(arr);
    this.commit('WindFarm/SET_POLYGONS', [...newArr]);
  },

  SET_RAW_POLYGONS(state, payload) {
    const { type, data = [] } = payload;

    state.rawPolygons[type] = {
      data: data.map(item => {
        findDeepObj(item, findItem => {
          findItem.type = type;
        });
        return item;
      })
    };

    const arr = [];
    Object.keys(state.rawPolygons).forEach((i, index) => {
      arr[index] = state.rawPolygons[i].data;
    });

    const newArr = flattenDepth(arr);

    this.commit('WindFarm/SET_POLYGONS', [...newArr]);
  },

  SET_RAW_MARKERS(state, payload) {
    const { type, data = [] } = payload;

    Reflect.deleteProperty(state.rawMarkers, type);

    state.rawMarkers[type] = {
      data: data.map(item => {
        return { ...item, type };
      }),
      indexStore: []
    };

    const arr = [];
    Object.keys(state.rawMarkers).forEach((i, index) => {
      arr[index] = state.rawMarkers[i].data;
    });

    const newArr = flatten(arr);

    this.commit('WindFarm/SET_MARKERS', [...newArr]);
  },

  DEL_RAW_POLYGONS_BY_KEY(state, key) {
    const _polygonsObj = cloneDeep(state.rawPolygons);
    Reflect.deleteProperty(_polygonsObj, key);

    const arr = [];
    Object.keys(_polygonsObj).forEach((i, index) => {
      arr[index] = _polygonsObj[i];
    });

    const newArr = flatten(arr);
    this.commit('WindFarm/SET_POLYGONS', [...newArr]);
  },

  SET_TOOL_UI_STATUS(state, payload) {
    const { key, value } = payload;
    state.toolUIStatus[key] = value;
    state.toolbarStatus = { ...state.toolbarStatus };
  },

  SET_TOOL_BAR_STATUS(state, payload) {
    const { key, value } = payload;
    const obj = {
      [key]: value
    };
    state.toolbarStatus = { ...obj };
  },

  SET_CHANGEFLAG(state, payload) {
    state.specificChangeFlag = payload;
  },

  SET_ROADLENGTH(state, payload) {
    state.roadLength = payload;
  },

  POP_MAPDATA_POLYGONS(state) {
    state.mapData.polygons.pop();
    state.mapData.polygons = [...state.mapData.polygons];
    state.mapData = { ...state.mapData };
  },
  POP_MAPDATA_RECT(state) {
    state.mapData.rectangles.pop();
    state.mapData.polygons = [...state.mapData.rectangles];
    state.mapData = { ...state.mapData };
  },
  // 删除点显示
  POP_MAP_POINT(state) {
    state.mapData.markers.pop();
    state.mapData = { ...state.mapData };
  },
  SET_EXCLUSIVELIST(state, payload) {
    state.exclusiveList = payload;
  },
  SET_BOOSTERLIST(state, payload) {
    state.boosterList = payload;
  },
  SET_ROADLINE(state, payload) {
    state.roadLine = payload;
  },
  SET_KEYPOINTS(state, payload) {
    state.keyPointsList = payload;
  },
  SET_ENTRANCELISTS(state, payload) {
    state.entrancePointList = payload;
  },
  SET_DATASET(state, payload) {
    state.dataSet = payload;
  },
  SET_TURLIST(state, payload) {
    state.turbineList = payload;
  },
  SET_ROADLIST(state, payload) {
    state.windfarmRoadList = payload;
  },

  SET_GANTALIST(state, payload) {
    state.gantaPointList = payload;
  },

  SET_WRGINFO(state, payload) {
    state.wrgInfoForm = payload;
  },

  SET_TUPUOBJ(state, payload) {
    state.resourceTupuObj = payload;
  },

  SET_ROADSLOPE(state, payload) {
    state.roadSlope = payload;
  },

  SET_WIRE_FORM(state, payload) {
    state.windfarmWireForm = payload;
  },

  UPDATE_WIRE_LIST(state, payload) {
    let myarr = payload || state.windfarmWireList;

    const lineType = [];

    const arr = myarr
      .filter(i => !!i.isShow)
      .map((item, index) => {
        // 类型为 MultiLineString ，需要转换成多条线

        const parseItem = JSON.parse(item.wireSection);
        lineType.push(parseItem.type);

        if (parseItem.type === 'LineString') {
          const a = [parseItem.coordinates].map(coords => {
            return L.GeoJSON.coordsToLatLngs(coords).map(latlng => ({
              ...latlng,
              type: 'wirelist',
              wireId: item.wireId,
              index: index
            }));
          });

          return a;
        } else {
          const b = parseItem.coordinates.map(coords => {
            return L.GeoJSON.coordsToLatLngs(coords).map(latlng => ({
              ...latlng,
              type: 'wirelist',
              wireId: item.wireId,
              index: index
            }));
          });
          return b;
        }
      });

    sessionStorage.setItem('CURRENT_JSONTYPE', JSON.stringify(lineType));

    this.commit('WindFarm/SET_RAW_LINE', {
      type: 'wireList',
      data: arr,
      t: 'arr'
    });
  },

  UPDATE_ROAD_LIST(state, payload) {
    let myarr = payload || state.windfarmRoadList;

    const arr = myarr
      .filter(i => !!i.isShow)
      .map(item => {
        return L.GeoJSON.coordsToLatLngs(
          JSON.parse(item.roadSections).coordinates
        ).map(latlng => ({
          ...latlng,
          type: 'roadlist',
          roadId: item.roadId
        }));

        // const data = JSON.parse(item.roadSections).coordinates.map(idata => {
        //   return {
        //     type: 'roadlist',
        //     roadId: item.roadId,
        //     lat: idata[1],
        //     lng: idata[0]
        //   };
        // });

        // return data;
      });

    this.commit('WindFarm/SET_RAW_LINE', {
      type: 'roadlist',
      data: arr
    });
  },

  // UPDATE_WIRE_LIST(state, payload) {
  //   let myarr = payload || state.windfarmWireList;

  //   const arr = myarr
  //     .filter(i => !!i.isShow)
  //     .map((item, index) => {
  //       const myitem = JSON.parse(item.wireSection).coordinates;

  //       if (Array.isArray(myitem)) {
  //         const newItem = myitem.map(i => {
  //           return {
  //             type: 'wirelist',
  //             wireId: item.wireId,
  //             index: index,
  //             lat: i[1],
  //             lng: i[0]
  //           };
  //         });
  //         return newItem;
  //       }
  //     });

  //   this.commit('WindFarm/SET_RAW_LINE', {
  //     type: 'wireList',
  //     data: arr
  //   });
  // },

  // UPDATE_ROAD_LIST(state, payload) {
  //   let myarr = payload || state.windfarmRoadList;

  //   const arr = myarr
  //     .filter(i => !!i.isShow)
  //     .map(item => {
  //       const data = JSON.parse(item.roadSections).coordinates.map(idata => {
  //         return {
  //           type: 'roadlist',
  //           roadId: item.roadId,
  //           lat: idata[1],
  //           lng: idata[0]
  //         };
  //       });

  //       return data;
  //     });

  //   this.commit('WindFarm/SET_RAW_LINE', {
  //     type: 'roadlist',
  //     data: arr
  //   });
  // },

  UPDATE_KEY_POINTS(state, payload) {
    let myarr = payload || state.keyPointsList;
    this.commit('WindFarm/SET_RAW_MARKERS', {
      type: 'keypoint',
      data: myarr
        .filter(i => !!i.isShow)
        .map(i => {
          return {
            icon: keyPointSrc,
            iconSize: [15, 15],
            iconAnchor: [7.5, 15],
            pointId: i.pointId,
            pointType: i.pointType,
            lat: i.lat,
            lng: i.lon
          };
        })
    });
  },

  UPDATE_GANTALIST(state, payload = {}) {
    const {
      data = null,
      activeId = -1,
      callback = () => {},
      force = false,
      circuit = 'all'
    } = payload;

    let myArr = data || state.gantaPointList;

    if (!force && activeId !== -1 && storeGantaActiveId === activeId) {
      return;
    }

    storeGantaActiveId = activeId;

    this.commit('WindFarm/SET_RAW_MARKERS', {
      type: 'gantaPoint',
      data: myArr
        .filter(i => !!i.isShow && state.specificChangeFlag)
        .filter(i => {
          if (circuit === 'all') {
            return true;
          }
          return i.circuit === circuit;
        })
        .map(i => {
          return {
            circuit: i.circuit,
            gantaId: i.id,
            lat: i.lat,
            lng: i.lon,
            icon: activeId === i.id ? activeGantaIcon : gantaIcon
          };
        })
    });

    callback && callback();
  },

  UPDATE_EXCLUSIVE_LIST(state, payload) {
    let myarr = payload || state.entrancePointList;
    this.commit('WindFarm/SET_RAW_MARKERS', {
      type: 'entrance',
      data: myarr
        .filter(i => !!i.isShow)
        .map(i => {
          return {
            icon: entryPoint,
            iconSize: [15, 15],
            iconAnchor: [7.5, 15],
            pointId: i.pointId,
            pointType: i.pointType,
            lat: i.lat,
            lng: i.lon
          };
        })
    });
  },

  UPDATE_TUILIST(state, payload = {}) {
    const {
      data = null,
      activeId = -1,
      callback = () => {},
      force = false
    } = payload;
    let myarr = data || state.turbineList;

    if (!force && activeId !== -1 && storeActiveId === activeId) {
      return;
    }

    storeActiveId = activeId;

    this.commit('WindFarm/SET_RAW_MARKERS', {
      type: 'fengji',
      data: myarr
        .filter(i => !!i.isShow)
        .map((i, index) => {
          const circuit =
            state.windfarmWireForm?.type == 1
              ? i.circuitOverhead
              : i.circuitBuried;

          const iconDiv = L.divIcon({
            iconSize: [40, 40],
            iconAnchor: [20, 40],
            className: 'div-icon-markers-fengji',
            html: `<div class="wrapper">
            ${
              circuit && state.isInlinePage
                ? '<span class="desc">' +
                  circuit +
                  ':' +
                  '#' +
                  (index + 1) +
                  '</span>'
                : state.showFengjiNoFlag
                ? '<span class="desc">' + '#' + (index + 1) + '</span>'
                : ''
            }
            <img src="${
              activeId === i.turbineId ? activeFengjiIcon : fengjiIcon
            }" alt=""/></div>`
          });

          return {
            turbineId: i.turbineId,
            icon: iconDiv,

            lat: i.lat,
            lng: i.lon
          };
        })
    });
    callback && callback();
  },
  UPDATE_LIMIT_AREA(state, payload) {
    let myarr = payload || state.exclusiveList;

    const arr = myarr
      .filter(i => !!i.isShow)
      .map(item => {
        const data = parseGeoInfoToMapData(item.geometryInfo)[0].map(i => ({
          ...i,
          type: 'deploy-condition'
        }));
        return data;
      });

    this.commit('WindFarm/SET_RAW_POLYGONS', {
      type: 'deploy-condition',
      data: arr
    });
  },
  UPDATE_BOOST_AREA(state, payload) {
    let myarr = payload || state.boosterList;

    this.commit('WindFarm/SET_RAW_MARKERS', {
      type: 'shengdanzhan',
      data: myarr
        .filter(i => !!i.isShow)
        .map(i => {
          return {
            icon: syzIcon,
            lat: i.lat,
            lng: i.lon
          };
        })
    });
  },

  SET_POLYLINESINDEXS(state, payload) {
    state.polylinesIndexs = payload;
  },

  SET_LINE_EDIT(state, payload) {
    const {
      type = '',
      mapInstance = null,
      update,
      key = 'specificEditFlag',
      force = false
    } = payload;

    const { polylines = [] } = state.mapData;

    if (mapInstance) {
      if (force) {
        state[key] = true;

        const polylinesIndexs = polylines.reduce((acc, cur) => {
          const itemType = findDeepAttr(cur);

          if (itemType === type) {
            const index = polylines.findIndex(i => i === cur);

            acc.unshift(index);
            return acc;
          }
          return acc;
        }, []);

        sessionStorage.setItem('temp_polyGroup', JSON.stringify(polylines));

        this.commit('WindFarm/SET_POLYLINESINDEXS', polylinesIndexs);
        return;
      }

      if (state[key]) {
        state[key] = false;

        update && update();
      } else {
        state[key] = true;

        const polylinesIndexs = polylines.reduce((acc, cur) => {
          const itemType = findDeepAttr(cur);

          if (itemType === type) {
            const index = polylines.findIndex(i => i === cur);

            acc.unshift(index);
            return acc;
          }
          return acc;
        }, []);

        sessionStorage.setItem('temp_polyGroup', JSON.stringify(polylines));

        this.commit('WindFarm/SET_POLYLINESINDEXS', polylinesIndexs);
      }
    }

    function findDeepAttr(data) {
      if (!data) return '';

      if (Array.isArray(data)) {
        return findDeepAttr(data[0]);
      } else if (isObject(data)) {
        return data.type || '';
      }
    }
  },

  SET_specificDragFlag(state, payload) {
    state.specificDragFlag = payload;
  },

  SET_specificChangeFlag(state, payload) {
    state.specificChangeFlag = payload;
  },

  SET_MARKERS_DRAG(state, payload) {
    const {
      type = '',
      mapInstance = null,
      force = false,
      filter = () => true,
      status = null,
      key = 'specificDragFlag'
    } = payload;

    if (key === 'specificChangeFlag') {
      if (status) {
        setTimeout(() => {
          const { markers = [] } = state.mapData;

          const markersIndexs = markers.reduce((acc, cur) => {
            if (cur.type === type && filter(cur)) {
              const index = markers.findIndex(i => i === cur);
              acc.unshift(index);
              return acc;
            }
            return acc;
          }, []);

          sessionStorage.setItem(
            'JIAKLONG_MARKERS',
            JSON.stringify(markersIndexs)
          );

          markersIndexs.forEach(i => {
            mapInstance.shapes.markers[i].pm.enableLayerDrag();
            mapInstance.shapes.markers[i].on('dragstart', dragStart);
            mapInstance.shapes.markers[i].on('dragend', dragEnd);
            return;
          });
        }, 0);
      } else {
        const { markers = [] } = state.mapData;

        const markersIndexs = markers.reduce((acc, cur) => {
          if (cur.type === type && filter(cur)) {
            const index = markers.findIndex(i => i === cur);
            acc.unshift(index);
            return acc;
          }
          return acc;
        }, []);
        markersIndexs.forEach(i => {
          mapInstance.shapes.markers[i].pm.disableLayerDrag();
          mapInstance.shapes.markers[i].off('dragstart', dragStart);
          mapInstance.shapes.markers[i].off('dragend', dragEnd);
          return;
        });
      }

      return;
    }

    const { markers = [] } = state.mapData;

    const markersIndexs = markers.reduce((acc, cur) => {
      if (cur.type === type && filter(cur)) {
        const index = markers.findIndex(i => i === cur);
        acc.unshift(index);
        return acc;
      }
      return acc;
    }, []);

    if (status !== null) {
      if (!status) {
        markersIndexs.forEach(i => {
          mapInstance.shapes.markers[i].pm.disableLayerDrag();
          mapInstance.shapes.markers[i].off('dragstart', dragStart);
          mapInstance.shapes.markers[i].off('dragend', dragEnd);
          return;
        });
      } else if (status) {
        markersIndexs.forEach(i => {
          mapInstance.shapes.markers[i].pm.enableLayerDrag();
          mapInstance.shapes.markers[i].on('dragstart', dragStart);
          mapInstance.shapes.markers[i].on('dragend', dragEnd);
          return;
        });
      }
    } else {
      if (mapInstance && !force) {
        if (state[key]) {
          markersIndexs.forEach(i => {
            mapInstance.shapes.markers[i].pm.disableLayerDrag();
            mapInstance.shapes.markers[i].off('dragstart', dragStart);
            mapInstance.shapes.markers[i].off('dragend', dragEnd);
            return;
          });
          state[key] = false;
        } else {
          state[key] = true;
          markersIndexs.forEach(i => {
            mapInstance.shapes.markers[i].pm.enableLayerDrag();
            mapInstance.shapes.markers[i].on('dragstart', dragStart);
            mapInstance.shapes.markers[i].on('dragend', dragEnd);
            return;
          });
        }
      }

      if (force && mapInstance) {
        if (state.specificDragFlag) {
          markersIndexs.forEach(i => {
            mapInstance.shapes.markers[i].pm.enableLayerDrag();
            mapInstance.shapes.markers[i].on('dragstart', dragStart);
            mapInstance.shapes.markers[i].on('dragend', dragEnd);
            return;
          });
        } else {
          markersIndexs.forEach(i => {
            mapInstance.shapes.markers[i].pm.disableLayerDrag();
            mapInstance.shapes.markers[i].off('dragstart', dragStart);
            mapInstance.shapes.markers[i].off('dragend', dragEnd);
            return;
          });
        }
      }
    }
  },

  RESET_UI_AND_BAR_STATUS(state, cb = () => {}) {
    state.toolbarStatus = {
      drag: false,
      edit: false,
      remove: false,
      drawCircleMarker: false,
      drawMarker: false,
      drawPolyline: false,
      drawRectangle: false,
      drawPolygon: false
    };

    state.toolUIStatus = {
      search: false,
      marker: false,
      rectangle: false,
      polygon: false,
      newFarm: false,
      importFarm: false,
      shengyazhanAdd: false,
      limitAdd: false,
      entrance: false,
      keyPoint: false,
      lxLimitAdd: false,
      fengji: false,
      exclusive: false
    };

    state.drawOptions = {
      templineStyle: {
        color: '#478beb'
      },
      // the line from the last marker to the mouse cursor
      hintlineStyle: {
        color: '#478beb',
        dashArray: [5, 5]
      }
    };
    eventBus.$emit('getMapInstance', map => {
      map?.setDefaultIcon();
    });
    cb && cb();
  },
  CLEAN_MAP(state) {
    state.rawPolygons = {};
    state.rawMarkers = {};
    state.rawLines = {};
    state.resourceTupuObj = {};
    state.mapData = {
      points: [],
      polylines: [],
      polygons: [],
      rectangles: [],
      images: [],
      markers: []
    };
    state.specificChangeFlag = false;
    state.specificDragFlag = false;
    state.specificShengDianZhanFlag = false;
    state.specificEditFlag = false;
  },
  SET_POINT_ITEM(state, payload) {
    state.activePointItem = payload;
  }
};

const actions = {
  getDataSet(ctx) {
    fetch('/windfarm/project/getDataSet').then(res => {
      const { data = {} } = res;
      const { dataSet = [] } = data;
      ctx.commit('SET_DATASET', dataSet);
    });
  },
  getWindfarmExclusive(ctx, { params }) {
    const { commit } = ctx;

    fetch('/windfarm/windfarm/getWindfarmExclusive', {
      showError: true,
      params: {
        ...params
      }
    }).then(res => {
      const { data = {} } = res || {};
      let { windfarmExclusiveList = [] } = data;

      windfarmExclusiveList = windfarmExclusiveList.map(i => ({
        ...i,
        isShow: true
      }));

      commit('SET_EXCLUSIVELIST', windfarmExclusiveList);
      commit('UPDATE_LIMIT_AREA');
    });
  },
  getBoosterList(ctx, { params }) {
    fetch('/windfarm/windfarm/getWindfarmBoosterStation', {
      showError: true,
      params: {
        ...params
      }
    }).then(res => {
      const { data } = res;
      let { windfarmBoosterStationList = [] } = data;

      if (!windfarmBoosterStationList) {
        windfarmBoosterStationList = [];
      }

      windfarmBoosterStationList = windfarmBoosterStationList.map(i => ({
        ...i,
        isShow: true
      }));

      ctx.commit('SET_BOOSTERLIST', windfarmBoosterStationList);
      ctx.commit('UPDATE_BOOST_AREA');
      // ctx.commit('SET_RAW_MARKERS', {
      //   type: 'shengdanzhan',
      //   data: windfarmBoosterStationList
      //     .filter(i => !!i.isShow)
      //     .map(i => {
      //       return {
      //         lat: i.lat,
      //         lng: i.lon
      //       };
      //     })
      // });
    });
  },
  getWindfarmTurbineList(ctx, { params, callback = () => {} }) {
    fetch('/windfarm/windfarm/getWindfarmTurbineList', {
      showError: true,
      params: {
        ...params
      }
    }).then(res => {
      const { data = {} } = res || {};
      const { windfarmTurbineList = [] } = data;
      ctx.commit(
        'SET_TURLIST',
        windfarmTurbineList.map(i => ({
          ...i,
          isShow: true
        }))
      );
      ctx.commit('UPDATE_TUILIST');
      callback && callback();
    });
  },

  getRoadList(ctx, { params, callback }) {
    fetch('/windfarm/windfarm/getWindfarmRoad', {
      showError: true,
      params: {
        ...params
      }
    }).then(res => {
      const { data = {} } = res;

      let {
        windfarmRoadList = [],
        roadPointList = [],
        roadSlope = '',
        roadLength = ''
      } = data;

      const status = sessionStorage.getItem('CURRENT_ROAD_STATUS') || '1';
      windfarmRoadList = windfarmRoadList.map(i => {
        return {
          ...i,
          isShow: status === '1'
        };
      });

      roadPointList = roadPointList.map(i => {
        return {
          ...i,
          isShow: status === '1',
          isEdit: false
        };
      });

      const keyPointArr = roadPointList.filter(i => {
        return i.pointType === 2;
      });

      const entranceList = roadPointList.filter(i => {
        return i.pointType === 1;
      });

      ctx.commit('SET_ROADLIST', windfarmRoadList);
      ctx.commit('SET_KEYPOINTS', keyPointArr);
      ctx.commit('SET_ENTRANCELISTS', entranceList);
      ctx.commit('SET_ROADSLOPE', roadSlope);
      ctx.commit('SET_ROADLENGTH', roadLength);
      ctx.commit('UPDATE_ROAD_LIST');
      ctx.commit('UPDATE_KEY_POINTS');
      ctx.commit('UPDATE_EXCLUSIVE_LIST');

      callback && callback();
    });
  },

  getWrgInfo(ctx, { params, activeTupu = 0 }) {
    fetch('/windfarm/windfarm/getWrgInfo', {
      showError: true,
      params
    }).then(res => {
      const { data } = res;
      const hasTupu = !!data;

      const formSchme = {
        centralMeridian: '',
        conversionX: '',
        conversionY: '',
        conversionZ: '',
        zoneNo: '',
        zoneNoId: '',
        zoneWideId: '',
        sourceId: ''
      };

      const obj = {};

      if (hasTupu) {
        Reflect.ownKeys(formSchme).forEach(key => {
          obj[key] = data[key];
        });
        obj.wrgId = data.wrgId;
        obj.hasTupu = true;
        obj.windfarmId = params.windfarmId;
        ctx.commit('SET_WRGINFO', obj);

        if (activeTupu !== -1) {
          fetch('/windfarm/windfarm/createWrgPic', {
            showError: true,
            params: {
              elementCode: activeTupu == 0 ? 'wspd' : 'wpd',
              ...params
            }
          }).then(res => {
            const { data = {} } = res;
            ctx.commit('SET_TUPUOBJ', data);
            ctx.commit('SET_ACTIVE_TUPU_INDEX', activeTupu);
          });
        } else {
          ctx.commit('SET_TUPUOBJ', {});
          ctx.commit('SET_ACTIVE_TUPU_INDEX', -1);
        }
      } else {
        // 请求默认值
        ctx.commit('SET_TUPUOBJ', {});
        fetch('/windfarm/windfarm/getWrgDefaultConfig', {
          showError: true
        }).then(res => {
          const { data = {} } = res;
          Reflect.ownKeys(formSchme).forEach(key => {
            obj[key] = data[key];
          });
          obj.hasTupu = false;
          ctx.commit('SET_WRGINFO', obj);
          ctx.commit('SET_ACTIVE_TUPU_INDEX', -1);
        });
      }
    });
  },

  getWindFarmWire(ctx, { params, callback, usePrev = false, circuit = 'all' }) {
    fetch('/windfarm/windfarm/getWindfarmWire', {
      params
    }).then(res => {
      const { data = {} } = res || {};

      const {
        windfarmWireList = [],
        circuitLimit = 0,
        roadTowerList = []
      } = data;

      const status = sessionStorage.getItem('CURRENT_LINE_STATUS') || '1';

      const arr = windfarmWireList.map(item => {
        const prevItem = ctx.state.windfarmWireList.find(
          i => i.wireId === item.wireId
        );

        return {
          ...item,
          isEdit: usePrev && prevItem ? prevItem.isEdit : false,
          isShow: status === '1' && prevItem ? !!prevItem.isShow : true
        };
      });

      const gantaArr = roadTowerList.map(item => {
        return {
          ...item,
          isShow: params.type === '1'
        };
      });

      const windfarmWireForm = {
        cap: circuitLimit,
        type: params.type || '2'
      };

      sessionStorage.setItem('tempRawWireList', JSON.stringify(arr));

      ctx.commit('SET_GANTALIST', gantaArr);
      ctx.commit('UPDATE_GANTALIST', {
        circuit
      });
      ctx.commit('SET_WIRE_LIST', arr);
      ctx.commit('UPDATE_WIRE_LIST');
      ctx.commit('SET_WIRE_FORM', windfarmWireForm);

      callback && callback();
    });
  }
};

export function dragStart(e) {
  const data = e?.target?.__data;
  eventBus.$emit('dragStartFj', data);
}
export function dragEnd(e) {
  const data = e?.target?.__data;
  eventBus.$emit('dragEndFj', data);
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
